import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { get } from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import { Grid, Paper } from '@material-ui/core';

import { PaperHeader } from '../../app/components';
import MandatoryReview from './cards/MandatoryReview';
import SkipSurvey from './cards/SkipSurvey';
import CancelationPolicy from './cards/CancelationPolicy';
// import ServiceFee from './cards/ServiceFee';
import Support from './cards/Support';
import PaymentSettings from './cards/PaymentSettings';
import { loadTexts } from '../../config/texts';
const TEXT_KEY = 'organization';

class Organization extends React.Component {
  renderOrganizationName = () => {
    const texts = loadTexts(TEXT_KEY, this.props.locale);
    return (
      <Paper>
        <PaperHeader text={`${texts.header} ${this.props.organizationName}`} />
      </Paper>
    )
  };

  render() {
    return (
      <Grid container spacing={16}>
        <Grid item xs={12}>
          {this.renderOrganizationName()}
        </Grid>
        <Grid item xs={12}>
          <MandatoryReview />
        </Grid>
        <Grid item xs={12}>
          <SkipSurvey />
        </Grid>
        <Grid item xs={12}>
          <CancelationPolicy />
        </Grid>
        <Grid item xs={12}>
          <Support />
        </Grid>
        <Grid item xs={12}>
          <PaymentSettings />
        </Grid>
      </Grid>
    );
  }
};

const mapStateToProps = state => {
  const selectedOrganization = get(state, 'auth.selectedOrganization');
  const organizations = get(state, 'auth.data.user.organizations');
  const selected = (organizations.find(oid => oid._id === selectedOrganization) || { name: 'none' }).name;
  return {
    organizationName: selected,
    locale: state.appState.locale
  };
};

export default compose(
  withStyles(() => {}, { name: 'Organization' }),
  connect(mapStateToProps)
)(Organization);



// WEBPACK FOOTER //
// ./src/modules/organization/Scene.js